import Constant from '@/const';
import axios from 'axios';

const getAssurance = async () => {
  try {
    const response = await axios.get(Constant.apiUrl.concat('/insurance/'));
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getAssurance;
